<template>
    <div>
        <a-modal v-model="isVisible" :closable="false" title="Adjust pickup date" on-ok="handleOk">
            <template slot="footer">
                <a-button type="primary" @click="handleBtnUpdate">
                    Update
                </a-button>

                <a-button key="back" @click="handleBtnCancel">
                    Close
                </a-button>
            </template>
            <a-row>
                <a-form-model ref="pickupDateEditForm"
                            :model="pickupDateEditModel"
                            :rules="pickupDateEditRules"
                >
                    <a-row :gutter="[24]">
                        <a-col :span="12">
                            <a-form-model-item label="Pickup Time" prop="pickupTime">
                                <a-time-picker format="HH:mm" 
                                            :minuteStep="5"
                                            hideDisabledOptions
                                            inputReadOnly
                                            v-model="pickupDateEditModel.pickupTime" />
                            </a-form-model-item>
                        </a-col>

                        <a-col :span="12">
                            <a-form-model-item label="Pickup Date" prop="pickupDate">
                                <a-date-picker @change="onChange"
                                                :disabled-date="disabledDate"
                                                :format="dateFormatList"
                                                v-model="pickupDateEditModel.pickupDate"
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row> 
                </a-form-model>
            </a-row>

            <a-row>
               
            </a-row>
        </a-modal>
       
    </div>
</template>

<script>
import moment from 'moment';
import TimeFormatter from '../../../common/utils/TimeFormatter'
export default {

    data () {
        let checkPickupDate = (rule, value, callback) => {
            console.log('checkNewPickupDate is Called!')
            let validDate = moment().add(30, 'd');
            console.log('valid date:' + validDate)
            console.log('value: ' + value)
            if(value != null) {
                if(value == moment()) {
                    console.log('value:' + value)
                    callback(new Error('It can not be today!'));
                }
                if (value > validDate) {
                    callback(new Error('It should be within 30 days!'));
                }
                else {
                    callback();
                }
            }
            else {
                callback(new Error('Pickup date is not valid!'));
            }
            
        }


        return {
            orderId : null,
            pickupDateEditModel : {
                pickupTime : null,
                pickupDate : null
            },

            isVisible : false,
            dateFormatList: ['DD/MM/YYYY', 'DD/MM/YY'],
            pickupDateEditRules : {
                pickupTime : [
                    { 
                        trigger : 'change', 
                        message : 'Please pick a time',
                        required : true
                    }
                ],
                pickupDate : [
                    { 
                        validator: checkPickupDate, 
                        trigger: 'change', 
                        message : 'Please pick a date',
                        required : true,
                    }
                ]
            },
        }
    },
    
    methods : {

        show(record) {
            //console.log(order)
            this.isVisible = true;
            this.orderId = record.orderId;
        },

        handleOk ()  {
            this.isVisible = false;
            this.reset();
        },
        handleBtnCancel () {
            this.isVisible = false;
            this.reset();
        },

        handleBtnUpdate() {
            
            this.$message.loading('Updating data...', 5);

            this.$refs.pickupDateEditForm.validate(async valid => {

                if (valid) {
                    console.log('Valid!!!');
                    let record = {
                        orderId : this.orderId,
                        pickupTime : this.pickupDateEditModel.pickupTime,
                        pickupDate : this.pickupDateEditModel.pickupDate
                    }
                    console.log(record);
                    this.$store.dispatch('orderManager/updateOrderPickupDateAction', record);
			        let isSuccess = await this.$store.dispatch('orderManager/updateOrderPickupDateAction', record);
			
			        if(!isSuccess) {
				        this.$message.error('Something was wrong, please try again!', 5);
			        }
			        else {
					    this.$message.success('Update successfully!', 3);
			        }
                }
                else {
                    console.log('Invalid! Please check pickup time!')
                }
            });
            this.isVisible = false;
            this.reset();
			this.$message.destroy();
        },

        disabledDate(current) {
            let o = moment().endOf('day')
            let nextDay = moment().add(3, 'd');
            
            //console.log(nextDay)
            return (current < moment().endOf('day'));
        },

        onChange(e) {
            console.log(e.date() + ' - ' + e.format('MM') + ' - ' + e.format('yyyy'))
        },

      
        reset() {
            
            this.orderId = null;
            this.pickupDateEditModel.pickupTime = null;
            this.pickupDateEditModel.pickupDate = null;
        }
    }
}
</script>

<style scoped>
  
</style>